export enum LAUNCH_CALLER {
  CUSTOM_COMMENTS = 'CUSTOM_COMMENTS',
  CUSTOM_ADDED_TO_CART = 'CUSTOM_ADDED_TO_CART',
  UPDATE_DISPENSER_AGREEMENT_INFO = 'UPDATE_DISPENSER_AGREEMENT_INFO',
  CANCEL_DISPENSER_AGREEMENT = 'CANCEL_DISPENSER_AGREEMENT',
  CUSTOM_OPEN_CREDIT_CLAIM_ATTACHMENTS = 'CUSTOM_OPEN_CREDIT_CLAIM_ATTACHMENTS'
}
